export enum AcaoModificarPastas {
  ADICIONAR = 'ADICIONAR',
  REMOVER = 'REMOVER',
}
